import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./pop.module.css";
import { ThemeContext } from "../../context/ThemeContext";

export default function Popup(props) {
  const inputRef = useRef();
  const reAuthPassword = useRef();
  const searchRef = useRef();

  const fields = props.category || props.feature;
  const isFeature = props.valueType === "Enter New Feature";
  const popupTitle = isFeature ? "Select Features" : "Select Categories";
  const [searchQuery, setSearchQuery] = useState("");
  const [added, setAdded] = useState([]);
  const { isDarkMode } = useContext(ThemeContext);
  const [theme, setTheme] = useState(isDarkMode);
  const [isOpen, setIsOpen] = useState(false);
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

    useEffect(() => {
      setTheme(isDarkMode);
    }, [isDarkMode])
  const filteredFields = fields
    .filter((fieldName) => fieldName.toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => a.localeCompare(b)); 

  function getInputValue() {
    let inputValue = inputRef.current.value;
    if (inputValue) {
      if (isFeature) {
        setAdded((prev) => [...prev, inputValue]);
      } else {
        if (!added.includes(inputValue)) {
          setAdded((prev) => [...prev, inputValue]);
        }
      }
      inputRef.current.value = ""; 
    }
  }

  function handleAdd(fieldName) {
    if (isFeature) {
      setAdded((prev) => [...prev, fieldName]); 
    } else {
      if (!added.includes(fieldName)) {
        setAdded((prev) => [...prev, fieldName]); 
      }
    }
  }

  function handleCancel() {
    props.setIsPopupVisible(false);
  }

  function handleSubmit() {
    props.getValue(added, props.valueType);
    props.setIsPopupVisible(false);
  }
  const backgroundColorLightMode = 'white'
  const backgroundColorDarkMode = 'black'
  const textColorLightMode = 'black'
  const textColorDarkMode = 'white'
  const inputColorDarkMode = '#141414'
  return (
    <>
      <div
        className={styles["backdrop"]}
        onClick={() => props.setIsPopupVisible(false)}
      >
        <form
          onClick={(e) => e.stopPropagation()}
          onSubmit={(e) => e.preventDefault()}
          className={styles["popup"]}
          style={{ background: theme ? backgroundColorDarkMode : backgroundColorLightMode, color: theme ? textColorDarkMode : textColorLightMode }}

        >
          <h3 style={{ textAlign: "center", marginTop: 0, marginBottom: 0 }}>{popupTitle}</h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div>
            <button 
              onClick={() => setIsOpen(!isOpen)}
              style={{ 
                background: 'none',
                border: 'none',
                padding: '0',
                color: '#007bff',
                fontSize: '14px',
                cursor: 'pointer',
                marginTop: '0px',
                textDecoration: 'underline',
                textAlign: "left"
              }}
            >
              {isOpen ? 'Show Less' : 'Show Details'}
            </button>

            {isOpen && (
              <>
                {isFeature ? (
                  <>
                    <p className={styles.detailsText}>
                      Participants are encouraged to keep their user features up to date to ensure they receive relevant studies that match their profile. To maintain the integrity and reliability of our datasets, we apply reasonable limits on the frequency of profile updates.
                    </p>
                    <p className={styles.detailsText}>
                      To ensure a diverse and balanced participant pool, we cap the overrepresentation score for any single feature at 40%. For example, if four age groups are selected, we ensure that no single age group makes up more than 35% of the dataset (calculated as 25% × 1.4). This helps preserve data quality and integrity.
                    </p>
                    </>
                ) : (
                  <>
                   
                      <div style={{ marginTop: "4px", fontSize: "10px" }}>
                        <p className={styles.detailsText} style={{ margin: 0 }}>
                          Select the demographics to be investigated in your study by specifying categories of user features by their units, width (bin size), and start value. You can also create your own custom categories and features through the advanced tab by following <Link
                          to="/userFeatures-guidelines"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007bff", textDecoration: "underline" }}
                        >
                          this guide.
                        </Link>
                        </p>
                        <p className={styles.detailsText} style={{ margin: 0, marginTop: "8px" }}>
                          You can mix and match variations, but avoid selecting overlapping ranges because the feature importance score will be split among the overlapping features. Some examples of customized categories and features include:
                        </p>
                        <ul className={styles.detailsList} style={{ margin: 0, marginTop: "4px", paddingLeft: "22px" }}>
                          <li>Online Purchases per Month (width: 4): [0-3, 4-7, 8-11]</li>
                          <li>Online Purchases per Month (width: 4, start: 2): [2-5, 6-9, 10-13]</li>
                          <li>Online Purchases per Week: [0, 1, 2, 3]</li>
                        </ul>
                      </div>
                  </>
                )}
              </>
            )}
          </div>
          <div style={{ marginBottom: '4px' }}>
            <button
              onClick={() => setIsAdvancedOpen(!isAdvancedOpen)}
              style={{
                background: 'none',
                border: 'none',
                padding: '0',
                color: '#007bff',
                fontSize: '14px',
                cursor: 'pointer',
                marginTop: '0px',
                textDecoration: 'underline',
                textAlign: 'left',
              }}
            >
              {isAdvancedOpen ? 'Hide Advanced' : 'Advanced'}
            </button>
            {isAdvancedOpen && (
              <>
                
              <div className={styles.col} style={{ alignItems: "flex-start", marginTop: "8px" }}>
                <input ref={inputRef} type="text" placeholder={props.valueType.replace(/Enter New/i, "Enter Custom")} style={{ backgroundColor: theme ? inputColorDarkMode : backgroundColorLightMode }}
                />
                <button
                  onClick={getInputValue}
                  style={{ backgroundColor: "#008000", marginLeft: "10px", height: "35px", padding: "0 12px" }}
                >
                  Add
                </button>
              </div>
              </>
            )}
          </div>
          </div>

          {props.reAuth === true && (
            <div className={styles.reAuthSection}>
              <h3>Enter Previous Password</h3>
              <input
                type="password"
                ref={reAuthPassword}
                placeholder="Password"
                required
              />
            </div>
          )}

          {isFeature ? (
            props.selectedCategory && (
              <div className={styles.selectedCategory}>
                <h4>Selected Category: {props.selectedCategory}</h4>
              </div>
            )
          ) : null}
          <div className={styles.col}>
            <input
              ref={searchRef}
              type="text"
              placeholder="Search..."
              style={{ backgroundColor: theme ? inputColorDarkMode : backgroundColorLightMode , width: "100%" }}              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          

          <div className={styles.scrollableContainer}>
            {filteredFields.length > 0 ? (
              filteredFields.map((fieldName) => (
                <div
                  className={styles.col}
                  key={fieldName}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <label className={styles.listLabel}>{fieldName}</label>
                  <button
                    type="button"
                    onClick={() => handleAdd(fieldName)}
                    className={styles.listAddButton}
                    style={{
                      width: "80px",
                      marginLeft: "10px",
                      backgroundColor: "#008000",
                    }}
                  >
                    Add
                  </button>
                </div>
              ))
            ) : (
              <p>No matches found. Add manually instead.</p>
            )}
          </div>

          {added.length > 0 && (
            <div className={styles.added}>
              <h4 style={{ marginRight: "10px" }}>
                Added {isFeature ? "Feature" : "Categories"}:
              </h4>
              <span>{isFeature ? added.join(", ") : added.join(", ")}</span>
            </div>
          )}

          <div className={styles["button--container"]}>
            <button type="button" onClick={handleCancel}>Cancel</button>
            <button type="button" onClick={handleSubmit}>Next</button>
          </div>
        </form>
      </div>
    </>
  );
}
